import { Fragment, useState, useEffect } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import CollectionMenuPage from 'components/Menu/CollectionMenuPage'

export interface ProfileMenuModalProps<T> {
  isOwn: boolean
  saved: boolean
  setOpenShareModal: any
  saveCollection: any
  editCollection: any
  uploadNew: any
  importArtwork: any
  addTokenIds: any
  open: boolean
  onClose: () => void
}

const CollectionMenuModal = <T,>({
  open,
  onClose,
  isOwn,
  saved,
  setOpenShareModal,
  saveCollection,
  editCollection,
  uploadNew,
  importArtwork,
  addTokenIds,
}: ProfileMenuModalProps<T>) => {
  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <CollectionMenuPage
                isOwn={isOwn}
                saved={saved}
                setOpenShareModal={setOpenShareModal}
                saveCollection={saveCollection}
                editCollection={editCollection}
                uploadNew={uploadNew}
                importArtwork={importArtwork}
                addTokenIds={addTokenIds}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default CollectionMenuModal
